import _objectWithoutPropertiesLoose from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var _excluded = ["language", "value", "onChange", "copyButtonProps", "children", "id", "sx"];
import * as React from 'react';
import SimpleCodeEditor from 'react-simple-code-editor';
import Box from '@mui/material/Box';
import { NoSsr } from '@mui/base/NoSsr';
import { styled, alpha, useTheme } from '@mui/material/styles';
import prism from '@mui/internal-markdown/prism';
import { MarkdownElement } from '@mui/docs/MarkdownElement';
import { CodeCopyButton, useCodeCopy } from '@mui/docs/CodeCopy';
import { useTranslate } from '@mui/docs/i18n';
import { blueDark } from '@mui/docs/branding';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var StyledMarkdownElement = styled(MarkdownElement)(function (_ref) {
  var theme = _ref.theme;
  return [{
    '& .scrollContainer': _extends(_defineProperty({
      maxHeight: 'min(68vh, 1000px)',
      overflow: 'auto',
      marginTop: -1,
      backgroundColor: 'hsl(210, 25%, 9%)',
      // a special, one-off, color tailored for the code blocks using MUI's branding theme blue palette as the starting point. It has a less saturaded color but still maintaining a bit of the blue tint.
      border: '1px solid transparent',
      colorScheme: 'dark',
      '&:hover': {
        boxShadow: "0 0 0 3px ".concat(alpha(theme.palette.primary[500], 0.5))
      },
      '&:focus-within': {
        boxShadow: "0 0 0 3px ".concat(alpha(theme.palette.primary[500], 0.8))
      }
    }, theme.breakpoints.up('sm'), {
      borderRadius: '0 0 12px 12px'
    }), theme.applyDarkStyles({
      border: "1px solid ".concat((theme.vars || theme).palette.divider)
    })),
    '& pre': {
      // The scroll container needs to be the parent of the editor, overriding:
      // https://github.com/mui/material-ui/blob/269c1d0c7572fcb6ae3b270a2622d16c7e40c848/docs/src/modules/components/MarkdownElement.js#L27-L26
      maxWidth: 'initial',
      maxHeight: 'initial'
    },
    '& .MuiCode-copy': {
      display: 'none'
    }
  }];
});
var StyledSimpleCodeEditor = styled(SimpleCodeEditor)(function (_ref2) {
  var theme = _ref2.theme;
  return _extends({}, theme.typography.body2, {
    fontSize: theme.typography.pxToRem(13),
    fontFamily: theme.typography.fontFamilyCode,
    fontWeight: 400,
    WebkitFontSmoothing: 'subpixel-antialiased',
    color: '#f8f8f2',
    direction: 'ltr /*! @noflip */',
    "float": 'left',
    minWidth: '100%',
    '& textarea': {
      outline: 0
    },
    '& > textarea, & > pre': {
      // Override inline-style
      whiteSpace: 'pre !important'
    }
  });
});
export default function DemoEditor(props) {
  var language = props.language,
    value = props.value,
    onChange = props.onChange,
    copyButtonProps = props.copyButtonProps,
    children = props.children,
    id = props.id,
    sx = props.sx,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var t = useTranslate();
  var contextTheme = useTheme();
  var wrapperRef = React.useRef(null);
  var enterRef = React.useRef(null);
  var handlers = useCodeCopy();
  React.useEffect(function () {
    wrapperRef.current.querySelector('textarea').tabIndex = -1;
  }, []);
  return /*#__PURE__*/_jsx(StyledMarkdownElement, _extends({
    ref: wrapperRef,
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Tab') {
        return;
      }
      if (event.key === 'Escape') {
        enterRef.current.focus();
        return;
      }
      if (event.key === 'Enter') {
        var textarea = wrapperRef.current.querySelector('textarea');
        if (textarea !== document.activeElement) {
          event.preventDefault();
          event.stopPropagation();
          textarea.focus();
        }
      }
    },
    sx: sx
  }, other, {
    children: /*#__PURE__*/_jsxs("div", _extends({
      className: "MuiCode-root"
    }, handlers, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "scrollContainer",
        children: [/*#__PURE__*/_jsx(NoSsr, {
          children: /*#__PURE__*/_jsx(CodeCopyButton, _extends({}, copyButtonProps, {
            code: value
          }))
        }), /*#__PURE__*/_jsx(StyledSimpleCodeEditor, {
          padding: contextTheme.spacing(2),
          highlight: function highlight(code) {
            return "<code class=\"language-".concat(language, "\">").concat(prism(code, language), "</code>");
          },
          id: id,
          value: value,
          onValueChange: onChange
        })]
      }), /*#__PURE__*/_jsx(Box, {
        ref: enterRef,
        "aria-live": "polite",
        tabIndex: 0,
        sx: function sx(theme) {
          return {
            position: 'absolute',
            top: theme.spacing(1),
            padding: theme.spacing(0.2, 1, 0.5, 1),
            outline: 0,
            left: '50%',
            border: '1px solid',
            borderColor: blueDark[600],
            backgroundColor: blueDark[700],
            color: '#FFF',
            transform: 'translateX(-50%)',
            borderRadius: '6px',
            fontSize: theme.typography.pxToRem(13),
            transition: 'all 0.3s',
            boxShadow: '0 2px 4px rgba(0,0,0,0.5)',
            '&:not(:focus)': {
              top: 0,
              opacity: 0,
              pointerEvents: 'none'
            },
            '> kbd': {
              padding: theme.spacing(0.2, 0.4),
              backgroundColor: blueDark[500],
              fontSize: theme.typography.pxToRem(11),
              borderRadius: '6px',
              border: '1px solid',
              borderColor: blueDark[400]
            }
          };
        },
        dangerouslySetInnerHTML: {
          __html: t('editorHint')
        }
      }), children]
    }))
  }));
}